module.exports = "static/webpack/0a398a0d9b78056586c9c4c8324a1967.svg";